import getHeader from "./getHeader";
import getAnimation from "./getAnimation";
import getMarketingMessage from "./getMarketingMessage";

const getDefaultState = (
    currentPage,
    isLoggedIn,
    currentUser,
    hasMounted = false,
    ssrCookies = {}
) => {
    const animation = getAnimation(currentPage, isLoggedIn);
    const header = getHeader(currentPage);
    const marketingMessage = getMarketingMessage(currentUser, ssrCookies);

    return {
        hasMounted,
        hamburgerModalIsOpen: false,
        header,
        animation,
        marketingMessage,
        isCompact: false
    };
};

export default getDefaultState;
